/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.WalkinManagerDisplay {
    export class WalkinManagerDisplayContext {

        itemsArrayCtrl: any;
        selectAllBox: boolean;
        mode: Meevo.Model.MaintenanceFormState;
        private backup: any;

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService) {

            this.mode = Meevo.Model.MaintenanceFormState.Readonly;
        }

    }
}